import { render, staticRenderFns } from "./ImgTeam.vue?vue&type=template&id=4e885206"
import script from "./ImgTeam.vue?vue&type=script&lang=js"
export * from "./ImgTeam.vue?vue&type=script&lang=js"
import style0 from "./ImgTeam.vue?vue&type=style&index=0&id=4e885206&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports